export {
    legacyTrackEvent,
    legacySendEvent as sendEvent,
    sendEventFromAnalyticsBridge,
    trackError,
    getErrorData,
    sendAtlaskitUIEvent,
} from './listener';
